import { sendToServer } from './Requests';

export type MfaSetupResponse = {
  qrDataUrl: string;
};

export const requestMfaSetup = (userId: string) => sendToServer<MfaSetupResponse>(
  'POST',
  `/users/${userId}/mfa/totp/enrollment`,
);

export const verifyMfaCode = (userId: string, code: string) => sendToServer(
  'PUT',
  `/users/${userId}/mfa/totp/enrollment`,
  {},
  { code },
);